module.exports = __webpack_public_path__ + "images/company/badges/major_badge_30b278d25912e5ba08b3ba8e689e31f7.svg";